<template>

  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        รายงานแสดงการรับ-ส่งข้อมูลในบล็อกเชน (BlockChain)
        <small></small>
      </h1>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-body">
                <div class="wrapper_typegroup">
                  <div class="col-xs-12">
                    <h5>
                      รหัสรายการส่งเสริมการขาย :
                      <span>10010018484</span>
                    </h5>
                    <h5>
                      ชื่อรายการเสริมการขาย :
                      <span>postpaid</span>
                    </h5>
                    <h5>
                      ประเภทบริการของรายการส่งเสริมการขาย :
                      <span>postpaid</span>
                    </h5>
                    <h5>
                      ชนิดของรายการส่งเสริมการขาย :
                      <span>Main</span>
                    </h5>
                    <h5>
                      วันที่เสนอขาย :
                      <span>15/5/2019</span>
                    </h5>
                    <h5>
                      วันที่ให้บริการ :
                      <span>20/6/2019</span>
                    </h5>
                    <h5>
                      รูปแบบการคิดค่าบริการประเภทเสียง(วินาที/นาที) :
                      <span>300 นาที</span>
                    </h5>
                    <h5>
                      เงื่อนไขอื่นๆ/ข้อกำหนดของการให้บริการ :
                      <span>NBTC</span>
                    </h5>
                    <h5>
                      ลิ้งค์เว็บไซต์ หรือลิ้งค์รายการส่งเสริมการขาย ของผู้ให้บริการ์ :
                      <span>http://www.google.com</span>
                    </h5>
                    <h5>
                      หมายเลข USSD สำหรับเปลี่ยนรายการส่งเสริมการขาย :
                      <span>11005</span>
                    </h5>
                    <h5>
                      ลิ้งค์รูปโฆษณา หรือรูปรายการส่งเสริมการขาย:
                      <span>http://www.google.com</span>
                    </h5>
                    <h5>
                      ค่าบริการเหมาจ่ายตามสิทธิการใช้งาน :
                      <span>299 บาท</span>
                    </h5>
                    <h5>
                      ความเร็วดาวน์โหลด(Mbps) :
                      <span>300 Mbps</span>
                    </h5>
                    <h5>
                      ความเร็วอัปโหลด(Mbps) :
                      <span>257 Mbps</span>
                    </h5>
                    <h5>
                      บริการ Internet (บาท/Mbps) :
                      <span>299 บาท</span>
                    </h5>
                    <h4 class="text_left">การให้บริการเสริม (ที่คิดใช้ค่าบริการ)</h4>
                    <h5>
                      บริการความบันเทิง(Contents) :
                      <span>10010018484</span>
                    </h5>
                    <h5>
                      บริการโทรศัพท์เคลื่อนที่ (Voice) :
                      <span>10010018484</span>
                    </h5>
                    <h5>
                      บริการ Wifi :
                      <span>10010018484</span>
                    </h5>
                    <h5>
                      บริการ Fixed Line :
                      <span>10010018484</span>
                    </h5>
                    <h5>
                      บริการอื่นๆ :
                      <span>10010018484</span>
                    </h5>

                    <h4 class="text_left">การให้บริการเสริม (ที่ไม่มีค่าใช้บริการ)</h4>
                    <h5>
                      บริการความบันเทิง(Contents) :
                      <span>10010018484</span>
                    </h5>
                    <h5>
                      บริการโทรศัพท์เคลื่อนที่ (Voice) :
                      <span>10010018484</span>
                    </h5>
                    <h5>
                      บริการ Wifi :
                      <span>10010018484</span>
                    </h5>
                    <h5>
                      อุปกรณ์อื่นๆ :
                      <span>10010018484</span>
                    </h5>
                    <h5>
                      พรีเมี่ยม :
                      <span>10010018484</span>
                    </h5>
                    <h5>
                      การให้บริการอื่นๆ :
                      <span>10010018484</span>
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
    <!-- /.content -->
  </div>

</template>
<script>

  export default {
    data() {
      return {}
    },
    methods: {}
  }

</script>
